import type { NotificationPage } from "../api";
import type { StoredNotification } from "../types";

// Histórico de demonstração (newest-first) usado quando VITE_MOCK_NOTIFICATIONS
// está ligado. Espelha a semântica de cursor/keyset do agency-api: o cursor é o
// `receivedAt` do último item da página (opaco/base64); a próxima página são os
// itens com receivedAt menor.

const HOUR = 3_600_000;

function isoAgo(ms: number): string {
  return new Date(Date.now() - ms).toISOString();
}

const history: StoredNotification[] = [
  { id: "0190fe00-0000-7000-8000-000000000001", type: "SupportReplied", payload: { ticketId: "0190fb20-0000-7000-8000-000000000001", ticketCode: "TK-512", subject: "Dúvida sobre a fatura de maio" }, receivedAt: isoAgo(3 * HOUR), read: false },
  { id: "0190fe00-0000-7000-8000-000000000002", type: "BrokerJoined", payload: { brokerId: "0190fa10-0000-7000-8000-0000000000a2", brokerName: "Rafaela Souza" }, receivedAt: isoAgo(20 * HOUR), read: false },
  { id: "0190fe00-0000-7000-8000-000000000003", type: "SeatsLow", payload: { availableSlots: 2, planName: "Agency Pro" }, receivedAt: isoAgo(26 * HOUR), read: true },
  { id: "0190fe00-0000-7000-8000-000000000004", type: "LicenseActivated", payload: { brokerId: "0190fa10-0000-7000-8000-0000000000a3", brokerName: "Marcos Oliveira" }, receivedAt: isoAgo(2 * 24 * HOUR), read: true },
  { id: "0190fe00-0000-7000-8000-000000000005", type: "SupportReplied", payload: { ticketId: "0190fb20-0000-7000-8000-000000000002", ticketCode: "TK-498", subject: "Corretor não consegue acessar o app" }, receivedAt: isoAgo(3 * 24 * HOUR), read: true },
  { id: "0190fe00-0000-7000-8000-000000000006", type: "BrokerJoined", payload: { brokerId: "0190fa10-0000-7000-8000-0000000000a7", brokerName: "Camila Rocha" }, receivedAt: isoAgo(4 * 24 * HOUR), read: true },
  { id: "0190fe00-0000-7000-8000-000000000007", type: "LicenseActivated", payload: { brokerId: "0190fa10-0000-7000-8000-0000000000a8", brokerName: "Eduardo Lima" }, receivedAt: isoAgo(6 * 24 * HOUR), read: true },
  { id: "0190fe00-0000-7000-8000-000000000008", type: "SeatsLow", payload: { availableSlots: 4, planName: "Agency Pro" }, receivedAt: isoAgo(8 * 24 * HOUR), read: true },
];

const encode = (receivedAt: string): string => btoa(receivedAt);
const decode = (cursor?: string | null): string | null => {
  if (!cursor) return null;
  try {
    return atob(cursor);
  } catch {
    return null;
  }
};

export async function listNotifications(
  cursor?: string | null,
  limit = 20,
): Promise<NotificationPage> {
  const after = decode(cursor);
  const sorted = [...history].sort((a, b) =>
    b.receivedAt.localeCompare(a.receivedAt),
  );
  const filtered = after
    ? sorted.filter((n) => n.receivedAt < after)
    : sorted;
  const page = filtered.slice(0, limit);
  const last = page[page.length - 1];
  const hasMore = filtered.length > limit;
  await new Promise((r) => setTimeout(r, 150)); // simula latência
  return {
    items: page,
    nextCursor: hasMore && last ? encode(last.receivedAt) : null,
  };
}

export async function markRead(id: string): Promise<void> {
  const target = history.find((n) => n.id === id);
  if (target) target.read = true;
}

export async function markAllRead(): Promise<void> {
  history.forEach((n) => {
    n.read = true;
  });
}
